/*
    Take a slug, and add it to the end of
    our current baseURL!
*/

let cachedBaseURL = null;

export function buildListingLink(slug) {

    if (!cachedBaseURL) {
        let baseURL = window.location.pathname;
        const elm = document.getElementById('_dottie');

        if (elm) {
            const json = elm.getAttribute('content');
            const parsed = JSON.parse(json);
            baseURL = parsed && parsed.listPageLink ? parsed.listPageLink : baseURL;

            const stageParamIndex = baseURL.indexOf('?stage=Stage');
            if (stageParamIndex !== -1) {
                baseURL = baseURL.substring(0, stageParamIndex);
            }
        }
        cachedBaseURL = baseURL + (baseURL.endsWith('/') ? '' : '/');
    }

    return cachedBaseURL + 'listing/' + slug;
}
